// StatsigRuntime.tsx

import { useSlice } from "@bridge-applications/provider-kit";
import {
    useGateValue,
    useStatsigClient,
    useStatsigUser,
} from "@statsig/react-bindings";
import { useEffect } from "react";

const DEBUG_CONSOLE_GATE = "client_debug_console";
const DEBUG_CONSOLE_STORAGE_KEY = "__pbtg__debug-console-enabled";

export function StatsigRuntime() {
    const { state: authState } = useSlice("authSlice");
    const { user, updateUserAsync } = useStatsigUser();
    const { isLoading } = useStatsigClient();

    useEffect(() => {
        if (
            authState.bootstrapStatus !== "ready" ||
            !authState.userId ||
            user.userID === authState.userId
        ) {
            return;
        }
        void updateUserAsync({ userID: authState.userId }).catch(
            (error: unknown) => {
                console.error(
                    "[Statsig] Failed to update authenticated user",
                    error,
                );
            },
        );
    }, [
        authState.bootstrapStatus,
        authState.userId,
        updateUserAsync,
        user.userID,
    ]);

    const canEvaluateGate = !isLoading && !!user.userID;

    return canEvaluateGate ? <DebugConsoleGateCache /> : null;
}

function DebugConsoleGateCache() {
    const debugConsoleEnabled = useGateValue(DEBUG_CONSOLE_GATE);

    useEffect(() => {
        try {
            window.localStorage.setItem(
                DEBUG_CONSOLE_STORAGE_KEY,
                String(debugConsoleEnabled),
            );
        } catch {
            // Storage can be blocked or unavailable.
        }
    }, [debugConsoleEnabled]);

    return null;
}
